"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDERS_CONTAINER_ID = exports.MIN_NATIVE_BALANCE = exports.STALE_ALLOWANCE = exports.REFETCH_GAS_PRICE = exports.REFETCH_BALANCE = exports.REFETCH_USD = exports.REFETCH_ORDER_HISTORY = void 0;
exports.REFETCH_ORDER_HISTORY = 10000;
exports.REFETCH_USD = 10000;
exports.REFETCH_BALANCE = 10000;
exports.REFETCH_GAS_PRICE = 10000;
exports.STALE_ALLOWANCE = 10000;
exports.MIN_NATIVE_BALANCE = 0.01;
exports.ORDERS_CONTAINER_ID = "twap-orders-container";
